function debounce (fn, time) {
    let timeoutId
    return wrapper
    function wrapper (...args) {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
        timeoutId = setTimeout(() => {
            timeoutId = null
            fn(...args)
        }, time)
    }
}

export default debounce;